import I18n from 'app/i18n';
import {OtherItemInterface} from 'app/store/OtherItemStore';


export const otherItemName = (artifact: OtherItemInterface): string => {
    const {langs, title} = artifact;
    return langs && langs[I18n.locale] || title;
};
